var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("register-layout", {
    attrs: { step: 3 },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function () {
          return [
            _c("div", { staticClass: "register-step3" }, [
              _c("h2", [_vm._v("会員登録申し込み完了")]),
              _vm._v(" "),
              _c("h5", { staticClass: "bold" }, [
                _vm._v(
                  "\n                お申込み内容を確認後、認証コードをご登録住所宛て郵送いたしますので、しばらくお待ちください。\n            "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "b2" }, [
                _vm._v(
                  "\n                🙏 引き続き、インスタキャッシュをよろしくお願いします。\n            "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "b2" }, [
                _c("span", { staticClass: "emoji-warn" }, [_vm._v("⚠️ ")]),
                _vm._v(
                  "審査の結果、ご登録をいたしかねる場合がございますので、ご了承ください。\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "b2 bold", on: { click: _vm.nextStep } },
                [_vm._v("\n                トップに戻る\n            ")]
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }